import { useLocation, useParams } from 'react-router-dom';
import { useUI } from 'contexts/UiContext';
import { extractQueryData } from 'utils/services';
import { useGetRoleDetail } from 'api/services/rolesService';
import { useGetProductsTree } from 'api/services/productsService';
import {
  transformProductsToTreeData,
  transformToCompanyTree,
  transformToFdaProccesTree,
} from 'components/ui/roles/EditRoles/TreeSection/utils';
import { useGetFdaProcesses } from 'api/services/processesService';
import { useGetUsersByCompany } from 'api/services/userService';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useRoleDetails = () => {
  const { pathname } = useLocation();
  const isToDuplicate = pathname.includes('/duplicate');
  const { id: roleId } = useParams();
  const { selectedCompany } = useUI();
  const { t } = useTranslation();

  const roleDetailsData = useGetRoleDetail({
    companyId: selectedCompany || '',
    roleId: roleId || '',
  });
  let roleDetails = extractQueryData(roleDetailsData, undefined);

  const roleDetailsCopy = useMemo(() => {
    if (isToDuplicate && roleDetails) {
      return {
        ...roleDetails,
        id: '',
        type: 'CREATED_BY_USER',
        name: `${roleDetails.name} - Copy`,
      };
    }
    return roleDetails;
  }, [roleDetails, isToDuplicate]);

  const productTreeData = useGetProductsTree(selectedCompany || '');
  const productsTree = extractQueryData(productTreeData, []);
  const associatedProducts = transformProductsToTreeData(productsTree, t);

  const fdaProcesses = useGetFdaProcesses();
  const fdaProcessesData = extractQueryData(fdaProcesses, []);
  const associatedProcesses = transformToFdaProccesTree(fdaProcessesData);

  const allUsersByCompany = useGetUsersByCompany();
  const usersByCompany = extractQueryData(allUsersByCompany, []);

  const userCompanyTreeData = transformToCompanyTree(usersByCompany);

  const isLoading =
    roleDetailsData.isLoading ||
    productTreeData.isLoading ||
    fdaProcesses.isLoading ||
    allUsersByCompany.isLoading;
  const isError =
    roleDetailsData.isError ||
    productTreeData.isError ||
    fdaProcesses.isError ||
    allUsersByCompany.isError;

  return {
    roleDetails: roleDetailsCopy,
    associatedProducts,
    associatedProcesses,
    userCompanyTreeData,
    isLoading,
    isError,
  };
};
